
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SportsCategories from '../home/components/SportsCategories';
import BannerAd from '../../components/feature/BannerAd';
import { upcomingMatches } from '../../mocks/sportsData';
import Button from '../../components/base/Button';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLiveCategorys, getLiveList, getliveFocusAdd, getliveFocusDel } from '../../services/live';
import { message } from 'antd';
import { getadvertiseList } from '../../services/setting';

export default function Matches() {
  const navigate = useNavigate();
  // 分类统一为对象类型
  const [selectedSport, setSelectedSport] = useState<{ name: string } | null>({ name: '全部' });
  const [liveCategories, setLiveCategories] = useState<any[]>([]);
  const settingConfigInfo = useSelector((state: any) => state.settings.configInfo);
  // 分类对象数组，和首页/新闻页保持一致
  const categories = [
    { name: '全部' },
    { name: '足球' },
    { name: '篮球' },
    { name: '网球' },
    { name: '乒乓球' },
    { name: '羽毛球' },
    { name: '排球' },
    { name: '游泳' },
    { name: '田径' },
    { name: '电竞' },
    { name: 'F1' }
  ];
  const [selectedDate, setSelectedDate] = useState<string>('全部');
  const [searchQuery, setSearchQuery] = useState<string>(''); // 新增搜索状态
  const [selectedMatch, setSelectedMatch] = useState<any>(null);
  const [showMatchDetail, setShowMatchDetail] = useState(false);

  const [liveList, setLiveList] = useState<any[]>([]);
  
  const [adList, setAdList] = useState<any[]>([]);
  // 修改日期选项为时间段选择
  const getDateOptions = () => {
    return [
      { label: '全部', value: '全部' },
      { label: '今天', value: '今天' },
      { label: '明天', value: '明天' },
      { label: '本周', value: '本周' },
      { label: '本月', value: '本月' },
      { label: '今年', value: '今年' }
    ];
  };
  useEffect(() => {

    // 获取直播分类
    getLiveCategorys().then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data)) {
        setLiveCategories(res.data);
      }
    });

    // 获取广告列表
    getadvertiseList({ type: '3' }).then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        setAdList(res.data.lists);
      }
    });

  }, []);

  const handleAdClick = (url: string) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  useEffect(() => {
    let state = '0';

    const category_id = selectedSport && selectedSport.name !== '全部' ? selectedSport.id : '';
    const keyword = searchQuery || '';
    const getStartTime = () => {
      if (selectedDate === '全部') {
        return undefined;
      }
      const now = new Date();
      let startTime = new Date();

      switch (selectedDate) {
        case '今天':
          startTime.setHours(0, 0, 0, 0);
          break;
        case '明天':
          startTime.setDate(now.getDate() + 1);
          startTime.setHours(0, 0, 0, 0);
          break;
        case '本周':
          const day = now.getDay();
          const diff = now.getDate() - day + (day === 0 ? -6 : 1); // 将周一设为一周的开始
          startTime = new Date(now.setDate(diff));
          startTime.setHours(0, 0, 0, 0);
          break;
        case '本月':
          startTime = new Date(now.getFullYear(), now.getMonth(), 1);
          break;
        case '今年':
          startTime = new Date(now.getFullYear(), 0, 1);
          break;
        default:
          return undefined;
      }
      return startTime.getTime();
    };

    const start_time = getStartTime();
    getLiveList({ category_id, type: '', state, keyword, start_time }).then((res: any) => {
      if (res && res.status === 1 && Array.isArray(res.data?.lists)) {
        setLiveList(res.data.lists);
      } else if (res && res.status === 1 && Array.isArray(res.data)) {
        setLiveList(res.data);
      } else {
        setLiveList([]);
      }
    });
  }, [selectedSport, searchQuery, selectedDate]); // 依赖搜索关键词、分类和日期变化重新获取数据

  const getCategoryName = (categoryId: number) => {
    const category = liveCategories.find((cat: any) => cat.id === categoryId);
    return category ? category.name : '';
  };
  // 扩展赛事数据，添加更详细的信息
  const extendedMatches = [
    ...upcomingMatches,
    {
      id: 101,
      title: '拜仁慕尼黑 vs 多特蒙德',
      category: '足球',
      league: '德甲',
      status: 'upcoming',
      time: '今天 20:30',
      date: new Date().toLocaleDateString('zh-CN'),
      venue: '安联球场',
      importance: 'high',
      description: '德甲榜首大战，两队积分接近，这场比赛将直接影响联赛冠军归属。',
      homeTeam: '拜仁慕尼黑',
      awayTeam: '多特蒙德',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Bayern%20Munich%20vs%20Borussia%20Dortmund%20football%20match%20stadium%20atmosphere%2C%20professional%20sports%20photography&width=400&height=300&seq=match101&orientation=landscape',
      referee: '费利克斯·茨瓦耶尔',
      weather: '晴朗，18°C',
      tickets: '已售罄',
      predictions: {
        homeWin: 45,
        draw: 30,
        awayWin: 25
      },
      recentForm: {
        home: ['胜', '胜', '平', '胜', '负'],
        away: ['胜', '胜', '胜', '平', '胜']
      },
      headToHead: '近5次交锋：拜仁 2胜2平1负 多特',
      keyPlayers: {
        home: ['穆勒', '莱万多夫斯基', '诺伊尔'],
        away: ['哈兰德', '罗伊斯', '贝林厄姆']
      }
    },
    {
      id: 102,
      title: '热刺 vs 阿森纳',
      category: '足球',
      league: '英超',
      status: 'upcoming',
      time: '今天 23:00',
      date: new Date().toLocaleDateString('zh-CN'),
      venue: '温布利球场',
      importance: 'high',
      description: '北伦敦德比大战，两队历史交锋激烈，本场比赛关系到欧冠资格争夺。',
      homeTeam: '托特纳姆热刺',
      awayTeam: '阿森纳',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Tottenham%20vs%20Arsenal%20North%20London%20Derby%20football%20match%20stadium%2C%20intense%20atmosphere&width=400&height=300&seq=match102&orientation=landscape',
      referee: '迈克尔·迪恩',
      weather: '多云，15°C',
      tickets: '少量余票',
      predictions: {
        homeWin: 35,
        draw: 35,
        awayWin: 30
      },
      recentForm: {
        home: ['胜', '平', '负', '胜', '胜'],
        away: ['胜', '胜', '胜', '平', '负']
      },
      headToHead: '近5次交锋：热刺 1胜2平2负 阿森纳',
      keyPlayers: {
        home: ['凯恩', '孙兴慜', '洛里'],
        away: ['萨卡', '厄德高', '拉姆斯代尔']
      }
    },
    {
      id: 103,
      title: '快片 vs 雄鹿',
      category: '篮球',
      league: 'NBA',
      status: 'upcoming',
      time: '明天 10:30',
      date: new Date(Date.now() + 86400000).toLocaleDateString('zh-CN'),
      venue: '加密货币网站竞技场',
      importance: 'medium',
      description: 'NBA西部强队对阵东部劲旅，伦纳德回归后快片状态火热。',
      homeTeam: '洛杉矶快片',
      awayTeam: '密尔沃基雄鹿',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=LA%20Clippers%20vs%20Milwaukee%20Bucks%20NBA%20basketball%20game%20arena%20atmosphere%2C%20professional%20sports&width=400&height=300&seq=match103&orientation=landscape',
      referee: '托尼·布拉瑟斯',
      weather: '室内比赛',
      tickets: '有票',
      predictions: {
        homeWin: 52,
        draw: 0,
        awayWin: 48
      },
      recentForm: {
        home: ['胜', '胜', '胜', '负', '胜'],
        away: ['胜', '负', '胜', '胜', '平']
      },
      headToHead: '近5次交锋：快片 3胜2负 雄鹿',
      keyPlayers: {
        home: ['伦纳德', '乔治', '威斯布鲁克'],
        away: ['字母哥', '霍勒迪', '洛佩兹']
      }
    },
    {
      id: 104,
      title: '费德勒 vs 阿尔卡拉斯',
      category: '网球',
      league: 'ATP大师赛',
      status: 'upcoming',
      time: '明天 21:00',
      date: new Date(Date.now() + 86400000).toLocaleDateString('zh-CN'),
      venue: '印第安维尔斯',
      importance: 'high',
      description: '网坛传奇对阵新生代球王，经验与活力的终极碰撞。',
      homeTeam: '费德勒',
      awayTeam: '阿尔卡拉斯',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Federer%20vs%20Alcaraz%20tennis%20match%20professional%20court%20atmosphere%2C%20ATP%20tournament&width=400&height=300&seq=match104&orientation=landscape',
      referee: '主裁判：卡洛斯·莫亚德斯',
      weather: '晴朗，26°C',
      tickets: '热售中',
      predictions: {
        homeWin: 42,
        draw: 0,
        awayWin: 58
      },
      recentForm: {
        home: ['胜', '负', '胜', '胜', '负'],
        away: ['胜', '胜', '胜', '胜', '胜']
      },
      headToHead: '历史首次交锋',
      keyPlayers: {
        home: ['经验丰富', '网前技术'],
        away: ['年轻活力', '底线实力']
      }
    },
    {
      id: 105,
      title: '中国 vs 韩国',
      category: '乒乓球',
      league: 'WTT大满贯',
      status: 'upcoming',
      time: '后天 15:00',
      date: new Date(Date.now() + 172800000).toLocaleDateString('zh-CN'),
      venue: '新加坡体育馆',
      importance: 'high',
      description: '亚洲乒乓球巅峰对决，两国顶尖选手将展开激烈争夺。',
      homeTeam: '中国队',
      awayTeam: '韩国队',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=China%20vs%20Korea%20table%20tennis%20match%20WTT%20tournament%20professional%20sports%20arena&width=400&height=300&seq=match105&orientation=landscape',
      referee: '国际级裁判团',
      weather: '室内比赛',
      tickets: '火热售票中',
      predictions: {
        homeWin: 70,
        draw: 0,
        awayWin: 30
      },
      recentForm: {
        home: ['胜', '胜', '胜', '胜', '胜'],
        away: ['胜', '胜', '负', '胜', '负']
      },
      headToHead: '近5次交锋：中国 4胜1负 韩国',
      keyPlayers: {
        home: ['马龙', '樊振东', '王楚钦'],
        away: ['林钟勋', '张禹珍', '安宰贤']
      }
    },
    {
      id: 106,
      title: '巴西 vs 意大利',
      category: '排球',
      league: '国家联赛',
      status: 'upcoming',
      time: '后天 19:30',
      date: new Date(Date.now() + 172800000).toLocaleDateString('zh-CN'),
      venue: '里约热内卢',
      importance: 'medium',
      description: '排球强国对决，巴西主场迎战意大利，精彩程度值得期待。',
      homeTeam: '巴西',
      awayTeam: '意大利',
      homeScore: null,
      awayScore: null,
      thumbnail: 'https://readdy.ai/api/search-image?query=Brazil%20vs%20Italy%20volleyball%20match%20national%20league%20professional%20sports%20arena%20Rio&width=400&height=300&seq=match106&orientation=landscape',
      referee: '国际排联裁判',
      weather: '室内比赛',
      tickets: '售票中',
      predictions: {
        homeWin: 55,
        draw: 0,
        awayWin: 45
      },
      recentForm: {
        home: ['胜', '胜', '负', '胜', '胜'],
        away: ['胜', '负', '胜', '胜', '胜']
      },
      headToHead: '近5次交锋：巴西 3胜2负 意大利',
      keyPlayers: {
        home: ['加比', '卢卡斯', '布鲁诺'],
        away: ['朱塞佩', '米歇兰杰洛', '亚历山德罗']
      }
    }
  ];

  // 根据选择的体育项目、日期和搜索关键词筛选数据
  const filteredMatches = extendedMatches.filter((match: any) => {
    // 分类兼容对象和字符串
    const sportMatch = !selectedSport || selectedSport.name === '全部' || match.category === selectedSport.name;

    // 修改日期筛选逻辑
    let dateMatch = true;
    if (selectedDate !== '全部') {
      const matchDate = new Date(match.date);
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      switch (selectedDate) {
        case '今天':
          dateMatch = match.date === today.toLocaleDateString('zh-CN');
          break;
        case '明天':
          dateMatch = match.date === tomorrow.toLocaleDateString('zh-CN');
          break;
        case '本周':
          const startOfWeek = new Date(today);
          startOfWeek.setDate(today.getDate() - today.getDay());
          const endOfWeek = new Date(startOfWeek);
          endOfWeek.setDate(startOfWeek.getDate() + 6);
          dateMatch = matchDate >= startOfWeek && matchDate <= endOfWeek;
          break;
        case '本月':
          dateMatch = matchDate.getMonth() === today.getMonth() &&
            matchDate.getFullYear() === today.getFullYear();
          break;
        case '今年':
          dateMatch = matchDate.getFullYear() === today.getFullYear();
          break;
        default:
          dateMatch = true;
      }
    }

    // 修复搜索逻辑：增加联赛匹配，模糊匹配比赛标题、主队、客队名称和联赛名称
    const searchMatch = searchQuery === '' ||
      match.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      match.homeTeam?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      match.awayTeam?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      match.league?.toLowerCase().includes(searchQuery.toLowerCase());

    return sportMatch && dateMatch && searchMatch;
  });

  // 按重要程度和时间排序
  const sortedMatches = filteredMatches.sort((a: any, b: any) => {
    const importanceOrder = { 'high': 3, 'medium': 2, 'low': 1 };
    const aImportance = importanceOrder[a.importance as keyof typeof importanceOrder] || 1;
    const bImportance = importanceOrder[b.importance as keyof typeof importanceOrder] || 1;

    if (aImportance !== bImportance) {
      return bImportance - aImportance;
    }

    return a.time.localeCompare(b.time);
  });

  // 处理赛事详情按钮点击
  const handleMatchDetail = (match: any) => {
    navigate(`/matchesDetail/${match.id}`, { state: { match } });
    // navigate(`/matchesDetail/${'101'}`);
  };

  // 关闭详情弹窗
  const closeMatchDetail = () => {
    setShowMatchDetail(false);
    setSelectedMatch(null);
  };

  // 设置提醒功能
  const handleSetReminder = (match: any) => {
    // Optimistically update the UI for a responsive feel
    setLiveList(currentLiveList =>
      currentLiveList.map(item =>
        item.id === match.id ? { ...item, is_focus: item.is_focus ? 0 : 1 } : item
      )
    );

    // Call the appropriate API based on the current focus state
    const action = match.is_focus ? getliveFocusDel : getliveFocusAdd;
    action({ id: match.id }).then(res => {
      if (!res || res.status !== 1) {
        // If the API call fails, revert the state to its original value
        setLiveList(currentLiveList =>
          currentLiveList.map(item =>
            item.id === match.id ? { ...item, is_focus: match.is_focus } : item
          )
        );
        message.success(res?.info || '操作失败');
        // Optional: show an error message to the user
        console.error('Failed to update focus status:', res?.msg);
      } else {
        message.success(res?.info || '操作成功');
      }
    }).catch(error => {
      console.error('Error updating focus status:', error);
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <main>
        {/* 体育分类选择，统一对象传递，补全 categories 参数 */}
        <SportsCategories imageServer={settingConfigInfo?.image_server} categories={liveCategories} onCategorySelect={setSelectedSport} selectedCategory={selectedSport} />

        {/* 赛事预告内容区域 */}
        <section className="py-8 md:py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            {/* 调整为左右布局：左侧赛事列表，右侧广告 */}
            <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
              {/* 左侧：赛事列表区域 - 调整宽度 */}
              <div className="flex-1 lg:w-[85%]">
                <div className="bg-white rounded-lg shadow-sm p-6">
                  {/* 搜索框 - 新增到页面标题上方 */}
                  <div className="mb-6">
                    <div className="relative max-w-md">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <i className="ri-search-line text-gray-400"></i>
                      </div>
                      <input
                        type="text"
                        placeholder="搜索球队名称、比赛名称..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full pl-10 pr-10 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-colors text-sm bg-gray-50 hover:bg-white focus:bg-white"
                      />
                      {searchQuery && (
                        <button
                          onClick={() => setSearchQuery('')}
                          className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                        >
                          <i className="ri-close-line text-gray-400 hover:text-gray-600"></i>
                        </button>
                      )}
                    </div>
                    {searchQuery && (
                      <p className="mt-2 text-sm text-gray-500 flex items-center">
                        <i className="ri-information-line mr-1"></i>
                        正在搜索包含 "{searchQuery}" 的赛事
                      </p>
                    )}
                  </div>

                  {/* 页面标题和筛选器 */}
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
                    <div className="mb-4 md:mb-0">
                      <h1 className="text-2xl font-bold text-gray-900 mb-2">
                        {!selectedSport || selectedSport.name === '全部'
                          ? '全部赛事预告'
                          : `${selectedSport.name}赛事预告`}
                      </h1>
                      <p className="text-gray-600 text-sm">即将开始的精彩赛事，不容错过</p>
                    </div>

                    {/* 日期筛选器 */}
                    <div className="flex items-center space-x-4">
                      <div className="flex items-center text-sm text-gray-600">
                        <i className="ri-calendar-line mr-2"></i>
                        <span>按日期筛选：</span>
                      </div>
                      <select
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        className="border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none pr-8"
                      >
                        {getDateOptions().map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* 赛事列表 */}
                  {liveList.length === 0 ? (
                    <div className="text-center py-12">
                      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className={`text-gray-400 text-2xl ${searchQuery ? 'ri-search-line' : 'ri-calendar-event-line'
                          }`}></i>
                      </div>
                      <h3 className="text-lg font-medium text-gray-900 mb-2">
                        {searchQuery ? '未找到相关赛事' : '暂无赛事安排'}
                      </h3>
                      <p className="text-gray-500">
                        {searchQuery
                          ? `没有找到包含 "${searchQuery}" 的赛事，请尝试其他关键词`
                          : '当前筛选条件下没有找到相关赛事，请尝试其他筛选条件'
                        }
                      </p>
                      {searchQuery && (
                        <button
                          onClick={() => setSearchQuery('')}
                          className="mt-3 text-green-600 hover:text-green-700 text-sm cursor-pointer"
                        >
                          清除搜索条件
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="space-y-4">
                      {liveList.map((match: any, index: number) => (
                        <div
                          key={match.id}
                          className={`border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer ${match.importance === 'high'
                              ? 'border-red-200 bg-red-50/30'
                              : match.importance === 'medium'
                                ? 'border-yellow-200 bg-yellow-50/30'
                                : 'border-gray-200 bg-white'
                            }`}
                        >
                          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                            {/* 左侧：赛事信息 */}
                            <div className="flex-1 mb-3 md:mb-0">
                              <div className="flex items-center mb-2">
                                {/* 重要程度标识 */}
                                {match.importance === 'high' && (
                                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 mr-2">
                                    <i className="ri-fire-line mr-1"></i>
                                    热门
                                  </span>
                                )}
                                {match.importance === 'medium' && (
                                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 mr-2">
                                    <i className="ri-star-line mr-1"></i>
                                    推荐
                                  </span>
                                )}

                                {/* 体育类型和联赛 */}
                                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 mr-2">
                                  {getCategoryName(match.category_id)}
                                </span>
                                <span className="text-gray-600 text-sm">{match.league_name}</span>
                              </div>

                              {/* 赛事标题 */}
                              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                {`${match.home} vs ${match.away}`}
                              </h3>

                              {/* 场馆信息 */}
                              {match.venue && (
                                <div className="flex items-center text-sm text-gray-500">
                                  <i className="ri-map-pin-line mr-1"></i>
                                  <span>{match.venue}</span>
                                </div>
                              )}

                              {/* 右侧：时间和操作 */}
                            </div>

                            {/* 右侧：时间和操作 */}
                            <div className="flex flex-col md:items-end md:text-right">
                              {/* 比赛时间 */}
                              <div className="flex items-center mb-2 md:justify-end">
                                <i className="ri-time-line text-gray-400 mr-2"></i>
                                <span className="text-lg font-semibold text-gray-900">
                                  {match.start_time}
                                </span>
                              </div>

                              {/* 操作按钮 */}
                              <div className="flex items-center space-x-2">
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSetReminder(match);
                                  }}
                                  className={`inline-flex items-center px-3 py-1.5 border rounded-lg text-sm transition-colors cursor-pointer whitespace-nowrap ${match.is_focus
                                      ? 'border-green-500 bg-green-50 text-green-700'
                                      : 'border-gray-300 text-gray-600 hover:bg-gray-50'
                                    }`}
                                >
                                  <i className={`mr-1 ${match.is_focus ? 'ri-check-line' : 'ri-notification-line'}`}></i>
                                  {match.is_focus ? '已关注' : '设置提醒'}
                                </button>
                                <button
                                  onClick={() => handleMatchDetail(match)}
                                  className="inline-flex items-center px-3 py-1.5 bg-green-500 text-white rounded-lg text-sm hover:bg-green-600 transition-colors cursor-pointer whitespace-nowrap"
                                >
                                  <i className="ri-information-line mr-1"></i>
                                  赛事详情
                                </button>
                              </div>
                            </div>
                          </div>

                          {/* 底部分隔线（最后一项除外） */}
                          {index < liveList.length - 1 && (
                            <div className="border-b border-gray-100 mt-4 -mb-4 mx-4"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* 统计信息 */}
                  {liveList.length > 0 && (
                    <div className="mt-6 pt-4 border-t border-gray-100">
                      <div className="flex items-center justify-between text-sm text-gray-500">
                        <span>
                          共找到 {liveList.length} 场赛事
                          {selectedSport && selectedSport.name !== '全部' && ` · ${selectedSport.name}分类`}
                          {selectedDate !== '全部' && ` · ${selectedDate}`}
                          {searchQuery && ` · 搜索"${searchQuery}"`}
                        </span>
                        <div className="flex items-center">
                          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse mr-2"></div>
                          实时更新
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* 右侧：广告区域 - 占据15%宽度，仅在大屏幕显示 */}
              <div className="hidden lg:block lg:w-[15%] flex-shrink-0">
                <div className="sticky top-4 space-y-6">
                  {adList.map((ad) => (
                  <div 
                    key={ad.id} 
                    className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer"
                    onClick={() => handleAdClick(ad.jump_url)}
                  >
                    <div className="relative">
                      <img
                        src={settingConfigInfo?.image_server + ad.img}
                        alt={ad.title}
                        className="w-full h-32 object-cover object-top"
                      />
                      <div className="absolute inset-0 bg-black/20"></div>
                    </div>
                    
                    <div className="p-4">
                      <h4 className="font-bold text-gray-900 mb-2">{ad.title}</h4>
                      <p className="text-sm text-gray-600 mb-3">{ad.sub_title}</p>
                      <button className={`w-full bg-gradient-to-br from-blue-500 to-cyan-600 text-white py-2 px-4 rounded-lg font-medium hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap text-sm`}>
                        {ad.btn_tip}
                      </button>
                    </div>
                  </div>
                ))}
                  {/* 体育博彩广告 */}
                  {/* <div className="bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg p-4 text-white text-center">
                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-trophy-line text-xl"></i>
                    </div>
                    <h4 className="font-bold text-sm mb-2">体育竞猜</h4>
                    <p className="text-xs text-white/90 mb-3">预测比赛结果 赢取奖品</p>
                    <button className="bg-white text-green-600 px-3 py-1.5 rounded-lg font-semibold text-xs hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap w-full">
                      立即参与
                    </button>
                  </div> */}

                  {/* VIP会员广告 */}
                  {/* <div className="bg-gradient-to-br from-yellow-400 via-orange-500 to-red-500 rounded-lg p-4 text-white text-center">
                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-vip-crown-line text-xl"></i>
                    </div>
                    <h4 className="font-bold text-sm mb-2">VIP会员</h4>
                    <p className="text-xs text-white/90 mb-3">无广告 高清画质</p>
                    <button className="bg-white text-orange-600 px-3 py-1.5 rounded-lg font-semibold text-xs hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap w-full">
                      立即升级
                    </button>
                  </div> */}

                  {/* 直播提醒广告 */}
                  {/* <div className="bg-gradient-to-br from-blue-500 to-cyan-600 rounded-lg p-4 text-white text-center">
                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-notification-line text-xl"></i>
                    </div>
                    <h4 className="font-bold text-sm mb-2">赛事提醒</h4>
                    <p className="text-xs text-white/90 mb-3">不错过任何精彩</p>
                    <button className="bg-white text-blue-600 px-3 py-1.5 rounded-lg font-semibold text-xs hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap w-full">
                      开启提醒
                    </button>
                  </div> */}

                  {/* APP下载广告 */}
                  {/* <div className="bg-gradient-to-br from-purple-500 to-pink-600 rounded-lg p-4 text-white text-center">
                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-smartphone-line text-xl"></i>
                    </div>
                    <h4 className="font-bold text-sm mb-2">下载APP</h4>
                    <p className="text-xs text-white/90 mb-3">随时随地看比赛</p>
                    <button className="bg-white text-purple-600 px-3 py-1.5 rounded-lg font-semibold text-xs hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap w-full">
                      立即下载
                    </button>
                  </div> */}

                  {/* 运动装备广告 */}
                  {/* <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg p-4 text-white text-center">
                    <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                      <i className="ri-shopping-bag-line text-xl"></i>
                    </div>
                    <h4 className="font-bold text-sm mb-2">运动装备</h4>
                    <p className="text-xs text-white/90 mb-3">专业运动用品</p>
                    <button className="bg-white text-gray-800 px-3 py-1.5 rounded-lg font-semibold text-xs hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap w-full">
                      立即购买
                    </button>
                  </div> */}
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* 底部横幅广告 */}
        <section className="py-4 md:py-6 bg-gray-50">
          <div className="container mx-auto px-4">
            <BannerAd size="large" position="bottom" />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

